import http from './api'

const route = 'order/'

export default {
    saveOrder: (cartList, cartShopping, address, optionPayment) => {
        return http.post(route + 'saveOrder', {
            cartList: cartList,
            cartShopping: cartShopping,
            address: address,
            optionPayment: optionPayment,
        })
    },
}
